export default "__VITE_ASSET__DKa3TjnF__"